
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface AuthGuardProps {
  requireAuth?: boolean;
  children?: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ requireAuth = true, children }) => {
  const { loading, isAuthenticated, login } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Skip triggering login if a logout redirect is in-progress
    const suppressLogin = sessionStorage.getItem('authguard_logout_suppress_login');
    if (requireAuth && !loading && !isAuthenticated && !suppressLogin) {
      const next = location.pathname + location.search + location.hash;
      login(next);
    }
  }, [requireAuth, loading, isAuthenticated, location, login]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (requireAuth && !isAuthenticated) {
    return <div>Authenticating...</div>;
  }

  // Prefer rendering passed children; fallback to Outlet for nested route usage
  return <>{children ?? <Outlet />}</>;
};

export default AuthGuard;
